import { Typography } from "@kyan/ui";

import { useCloudflareStatus } from "#/services/vendor/hooks/useCloudflareStatus";
import { useIsCloudflareWarningDismissed } from "#/store/app/alerts/isCloudflareWarningDismissed";

export const useCloudflareWarningController = () => {
  const { isCloudflareWarningDismissed, setIsCloudflareWarningDismissed } =
    useIsCloudflareWarningDismissed();
  const { data } = useCloudflareStatus();
  const description = (
    <Typography primary size={12}>
      We&apos;ve received a notification from{" "}
      <a
        target="_blank"
        href={data?.url ?? ""}
        className="text-primary"
        rel="noopener noreferrer"
      >
        Cloudflare
      </a>{" "}
      about possible outages with their system - It&apos;s possible we are
      partially impacted by this.
    </Typography>
  );

  const isInvisible = !data?.shouldShowWarning || isCloudflareWarningDismissed;

  const dismiss = () => {
    setIsCloudflareWarningDismissed(true);
  };

  return { isInvisible, description, dismiss };
};
